module.exports = __webpack_public_path__ + "static/media/simulation.90169295.png";